import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DocumentService } from '../../providers/document.service';
import { DownloaderHelper } from '../../helpers/downloader.helper';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import {
  MAT_DIALOG_DATA,
  MatDialogActions, MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { Organization } from "../../../common/models/organization";
import { Athlete } from "../../../common/models/athlete";
import { FlexLayoutModule } from "@angular/flex-layout";
import { TranslateModule } from "@ngx-translate/core";
import { NgIf } from "@angular/common";
import { MatButton, MatButtonModule } from "@angular/material/button";

@Component({
  selector: 'app-document-preview-dialog',
  templateUrl: './preview-dialog.component.html',
  standalone: true,
  imports: [
    FlexLayoutModule,
    MatDialogContent,
    TranslateModule,
    NgIf,
    MatDialogTitle,
    MatDialogActions,
    MatButtonModule,
    MatDialogClose
  ],
  styleUrls: ['./preview-dialog.component.scss']
})
export class PreviewDialogComponent implements OnInit, OnDestroy {
    public imageBlobUrl : any;
    public isImg = true;

    public previewAvailable = false;

    private organization: Organization = {} as Organization;
    private athlete: Athlete = {} as Athlete;
    private document: any;
    private blob: Blob = new Blob();
    private subscriptions: Subscription[] = [];

    @ViewChild(MatButton) closeBtn: MatButton | undefined;

    constructor(
        private sanitizer: DomSanitizer,
        public documentProvider: DocumentService,
        public dialogRef: MatDialogRef<PreviewDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data : any,
    ) {
        this.organization = this.data.organization;
        this.athlete = this.data.athlete;
        this.document = this.data.document;
    }

    public ngOnInit(): void {
        this.subscriptions.push(
            this.documentProvider.download(this.organization, this.athlete, this.document).subscribe((response: any) => {
                const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
                this.blob = new Blob([response], { type: response.type });

                if (allowedTypes.indexOf(response.type) === -1) {
                    this.previewAvailable = false;
                }

                const reader = new FileReader();
                reader.readAsDataURL(this.blob);
                reader.addEventListener('load', () => {
                    this.imageBlobUrl = this.sanitizer.bypassSecurityTrustUrl(reader.result as string);
                }, false);
                this.previewAvailable = true;
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public download() {
      this.subscriptions.push(
        this.documentProvider.download(this.organization, this.athlete, this.document).subscribe((response: Response) => {
          DownloaderHelper.forceDownload(response as any as Blob, this.document.originalName?? 'document');
          if (this.closeBtn)
            this.closeBtn._elementRef.nativeElement.click();
        })
      );
    }
}
